import fromDtoToPerformance from 'dto/kpi/fromDtoToPerformance.dto';
import asArray from 'utils/arrays/asArray.util';
import fromAnyToInteger from 'utils/converters/fromAnyToInteger';
import fromObjectToEntries from 'utils/converters/object/fromObjectToEntries.util';

const createFromDtoToStylistsPerfInfo = (options) => {
  // NOTE: using a separate variable here so that the function will not be anonymous

  // noinspection UnnecessaryLocalVariableJS
  const fromDtoToStylistsPerfInfo = (dto) => {
    const { bgn, end } = options ?? {};

    const isForecast = dto?.results?.is_forecast;

    const stylists = fromObjectToEntries(dto?.results?.stylists ?? {}).map(([key, val]) => {
      const stylistId = fromAnyToInteger(key);

      return {
        stylistId,
        performances: asArray(val?.performance)
          .map(fromDtoToPerformance)
          .map((item) => ({ ...item, stylistId, bgn, end })),
      };
    });

    const performances = stylists.flatMap((stylist) => stylist?.performances);

    // TODO: reorder the stylists/performances based on a field named order

    return { bgn, end, isForecast, stylists, performances };
  };

  return fromDtoToStylistsPerfInfo;
};

// noinspection JSUnusedGlobalSymbols
export default createFromDtoToStylistsPerfInfo;
